import React, { useEffect, useState } from 'react'
import { getMilliSec, getMilliSecUTC, makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from '../sideMenu';
import DashboardHeader from '../topbar';
import * as CONSTANTS from "../../utils/CONSTANTS";
import Styles from "./styles.module.scss";
import Tab from "../../components/tab";
import { TabStripSelectEventArguments, TabStripTab, TabStrip } from "@progress/kendo-react-layout";
import TimesheetSettings from './timesheetSettings';
import CandidateTimesheet from './candidateTimesheet';
import { useLocation } from 'react-router-dom';
import { getCandidateTimesheet, getHistory, getHolidaysList, getPaymentSettings, getProviderEmailList, sendTimesheetReminder, updatePaymentSettings, uploadHolidayFile, getpositionsName } from './services';
import NotificationAlert from '../../components/notification';
import AddToEmail from '../../modal/addToEmail';
import CandidateTimesheetHistory from '../../modal/candidateTimesheetHistory';
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import file_download from "../../assets/images/file_download.svg"
import { useNavigate } from "react-router-dom";
import { storeSelectedRow } from '../../store/timeSheetSelectedRow/timeSheetSelectedSlice';
import mixpanelData from '../../utils/mixpanel';

const CompanyTimesheetSettings = () => {

  const companyValues = useLocation()
  const currentYear = new Date().getFullYear()
  const currentMonth  = new Date().toLocaleString('default', { month: 'long' })
 
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 4);
  const [selected, setSelected] = useState<number>(0);
  const [filterNumber, setFilterNumber] = useState<number>()
  const [filterValues, setFilterValues] = useState<any>()
  const [filterValue , setFilterValue ] = useState<any>()
  const [candidateFilterValue , setCandidateFilterValue] = useState<any>()
  const [positionName, setPositionName] = useState<any>()
  const companyData = JSON.parse(localStorage.getItem("TimesheetSettings") || "") || JSON.parse(localStorage.getItem("CompanyData") || "") || {}
  const BreadcrumsValues = [companyData.companyName];
  const [candidateSheetData, setCandidateSheetData] = useState<any>()
  const [sort, setSort] = useState<any>([]);
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [type, setType] = useState<string>('success')
  const [icon, setIcon] = useState<boolean>(false)
  const [defaultPaymentData, setDefaultPaymentData] = useState<any>()
  const [holidayList, setHolidayList] = useState<any>()
  const [toEmailModal, setToEmailModal] = useState<boolean>(false)
  const [candidateDetails, setCandidateDetails] = useState<any>()
  const [historyModal, setHistoryModal] = useState<boolean>(false)
  const [checkHistoryData, setCheckHistoryData] = useState<any>()
  const [providerEmailList, setProviderEmailList] = useState<any>()
  const [companyList, setCompanyList] = useState<any>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {

    getCandidateTimesheetForCompany(1, 25, '', '', '')
    getCompanyPaymentSettings()
    getCompanyHolidays()
    dispatch(storeSelectedRow([]))
    getPositionName()

  }, [])

  const getCompanyHolidays = () => {
    getHolidaysList(companyData.customerId).then((response) => {
      if (response && response.status === 1) {
        setHolidayList(response.data)
      }
    })
  }

  const getCompanyPaymentSettings = () => {
    getPaymentSettings(companyData.customerId).then((response) => {
      if (response && response.status === "1") {
        setDefaultPaymentData(response.data[0].paymentSettings)
      }
    })
  }

  const getCandidateTimesheetForCompany = (pageNumber?: number, pageSize?: number, search?: string, sort?: any,filters?: any) => {

    let body = {}
    if (filters) {
      body = {
        filters : filters,
        sort: {
          "sortBy": sort && sort.length > 0 ? sort[0] && sort[0].field : "startDate",
          "sortOrder": sort && sort.length > 0 ? sort[0] && sort[0].dir : "ASC"
        }
      }
      setFilterValue(filters)
    }
    else {
      body = {
        filters:{
          customerId: [companyData.customerId],
          "month": currentMonth,
          "year": currentYear
        },
        sort: {
          "sortBy": sort && sort.length > 0 ? sort[0] && sort[0].field : "startDate",
          "sortOrder": sort && sort.length > 0 ? sort[0] && sort[0].dir : "ASC"
        }
      }
      let filter = {
        "month": currentMonth,
        "year": currentYear
      }
      setFilterValues(filter)
    }
    getCandidateTimesheet(pageNumber, pageSize, search, body).then((response) => {
      if (response && response.status === 1) {
        setCandidateSheetData(response.data)
      }
    })
  }

  const submitSetting = (data: any) => {
    let body = {
      "customerId": companyData.customerId,
      "fileName": data.fileName,
      "paymentSettings": {
        "approvalNeeded": data.approvalNeeded && data.approvalNeeded === 1 ? false : true,
        "billingType": data.billingType && data.billingType === 1 ? "Type2" : "Type1",
        "companyPaidLeaveAllowed": data.companyPaidLeaveAllowed && data.companyPaidLeaveAllowed === 1 ? false : true,
        "companyPaidLeaveCount": data.companyPaidLeaveAllowed && data.companyPaidLeaveAllowed === 1 ? 0 : parseInt(data.companyPaidLeaveCount),
        "companyPaidHolidayAllowed": data.companyPaidHolidayAllowed && data.companyPaidHolidayAllowed === 1 ? false : true,
        "companyCarryForwardAllowed": data.companyCarryForwardAllowed && data.companyCarryForwardAllowed === 1 ? false : true,
        "companyCarryForwardLeaveCount": data.companyCarryForwardAllowed && data.companyCarryForwardAllowed === 1 ? 0 : parseInt(data.companyCarryForwardLeaveCount),
        "paidLeaveAllowed": data.paidLeave && data.paidLeave === 1 ? false : true,
        "paidLeaveCount": data.paidLeave && data.paidLeave === 1 ? 0 : parseInt(data.paidLeaveCount),
        "carryForwardAllowed": false,
        "carryForwardLeaveCount": 0,
        "payPeriod": data.payPeriod,
        "submittedBy": "RECRUITER",
        "submittedByLoginId": localStorage.getItem('loginId'),
        "submittedOn": getMilliSecUTC(new Date())
      }
    }  
    updatePaymentSettings(body).then((response) => {
      if (response && response.status === 1) {
        
        mixpanelData('New TG - Timesheet settings saved', {
          'source': `Recruiter saves company timesheet settings`,
          "distinct_id": localStorage.getItem('Email'),
          "Recruiter email" : localStorage.getItem('Email'),
          'Company name': response.data.customer_metadata && response.data.customer_metadata.companyName,
          'First name': response.data.customer_metadata && response.data.customer_metadata.firstName,
          'Candidate email': response.data.customer_metadata && response.data.customer_metadata.workEmail,
          "Company id": companyData.customerId,
          "Approval needed": data.approvalNeeded && data.approvalNeeded === 1 ? false : true,
          "Billing type": data.billingType && data.billingType === 1 ? "Type2" : "Type1",
          "Company paid leave allowed": data.companyPaidLeaveAllowed && data.companyPaidLeaveAllowed === 1 ? false : true,
          "Company paid leave count": data.companyPaidLeaveAllowed && data.companyPaidLeaveAllowed === 1 ? 0 : parseInt(data.companyPaidLeaveCount),
          "Company carry forward allowed": data.companyCarryForwardAllowed && data.companyCarryForwardAllowed === 1 ? false : true,
          "Company carry forward leave count": data.companyCarryForwardAllowed && data.companyCarryForwardAllowed === 1 ? 0 : parseInt(data.companyCarryForwardLeaveCount),
          "Paid leave allowed": data.paidLeave && data.paidLeave === 1 ? false : true,
          "Paid leave count": data.paidLeave && data.paidLeave === 1 ? 0 : parseInt(data.paidLeaveCount),
          "Carry forward allowed": data.leavesCarryForward && data.leavesCarryForward === 1 ? false : true,
          "Carry forward leave count": data.leavesCarryForward && data.leavesCarryForward === 1 ? 0 : parseInt(data.leaveNumber),
          "Pay period": data.payPeriod,
        })
        displayNotification("Payment settings updated")
        getCompanyPaymentSettings()
      }
    })
  }

  const pageChange = (pageSize: number, pageNumber: number) => {
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
    getCandidateTimesheetForCompany(page, pageSize, '', sort)
  }

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  }

  const applySort = (sort: any) => {
    getCandidateTimesheetForCompany(1, 25, '', sort)
  }

  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 3000);
  }

  const uploadList = (fileName: any) => {
    if (fileName) {
      let body = {
        "fileName": fileName,
        "customerId": companyData.customerId
      }
      uploadHolidayFile(body).then((response: any) => {
        if (response && response.statusCode === 200) {
          displayNotification("Holiday list uploaded successfully")
          getCompanyHolidays()
        }
      })
    }
  }

  const getHistoryDetails = (timesheetId: string) => {
    getHistory(timesheetId).then((response) => {
      if (response && response.status === 1) {
        setCheckHistoryData(response.data)
      }
    })
  }

  const getProviderDetails = (candidateId: string) => {
    getProviderEmailList(candidateId).then((response) => {
      if (response && response.status === 1) {
        setProviderEmailList(response.data && response.data.map((item: any) => item.email))
        setToEmailModal(true)
      }
    })
  }

  const sendReminder = (data: any) => {
    setCandidateDetails(data)
    if (data.sourcedBy === 'PROVIDER') {
      getProviderDetails(data.candidateId)
    }
    else {
      let body = {
        "timesheetId": data && data.timesheetId,
        "projectId": data && data.projectId,
        "loginId": data && data.candidateId,
        "userLoginId": localStorage.getItem('loginId'),
        "candidateType": `${data.sourcedBy} RESOURCE`,
        "candidateName": data.candidateName,
        "jobRole": data.position,
        "toEmail": [data.email]
      }
      sendTimesheetReminder(body).then((response) => {
        if (response && response.status === 1) {
          displayNotification("Reminder sent successfully")
        }
      })
    }
  }

  const sendReminderProvider = (data: any) => {
    let body = {
      "timesheetId": candidateDetails && candidateDetails.timesheetId,
      "projectId": candidateDetails && candidateDetails.projectId,
      "loginId": candidateDetails && candidateDetails.candidateId,
      "userLoginId": localStorage.getItem('loginId'),
      "candidateType": `PROVIDER RESOURCE`,
      "candidateName": candidateDetails.candidateName,
      "jobRole": candidateDetails.position,
      "toEmail": data.toEmail
    }
    sendTimesheetReminder(body).then((response) => {
      if (response && response.status === 1) {
        setToEmailModal(false)
        displayNotification("Reminder sent successfully")
      }
    })
  }

  const showHistory = (data: any) => {
    setHistoryModal(true)
    getHistoryDetails(data.timesheetId)
  }
  const timeSheetSelectedRow = useAppSelector(state => state.timeSheetSelectedRow);
  
  const redirection = () => {
    navigate('/candidatetimesheetdownload', {
      state: {
        timeSheetSelectedRow: timeSheetSelectedRow,
        year: "2022",
        month: "November",
        company_name: companyData.companyName
      }
    });
  }

  const getPositionName = () => {
    getpositionsName().then((response) => {
      if (response && response.status === 1) {
        setPositionName(response.data.map((item:any)=> item.title ? item.title : ''));
      }
    })
  }

  const applyFilter = (data: any) => {
    
    let filters = {
      positionName: data.positionName,
      status: data.status && data.status !== undefined && data.status.length > 0  ?  data.status.map((item: any) => item.name) : data.status ,
      invoiceRaised: data.invoiceRaised !== undefined ? data.invoiceRaised.name : data.invoiceRaised,
      dateWithin: data.dateWithin && data.dateWithin,
      month: data.month,
      year: data.year
    }
    setFilterValues(filters)
    let value = {
      customerId: [companyData.customerId],
      "status" : data.status && data.status !== undefined && data.status.length > 0 ? data.status.map((item: any) => item.id) : undefined,
      "position": data.positionName !== undefined ?  data.positionName : undefined,
      "invoiceRaised": data.invoiceRaised !== undefined ? (data.invoiceRaised.id === 0 ? true : false) : undefined,
      "month": data.month,
      "year": data.year,
      "submittedOn": data.dateWithin
    } 
    setCandidateFilterValue(data)
    getCandidateTimesheetForCompany(1, 25, '','',value)
  }

  const searchChange = (e: any) => {    
    getCandidateTimesheetForCompany(1, 25, e, sort, filterValue)
  }

  const closeTag = (data: any) => {
    applyFilter(data)
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          type='companyTimesheetSettings'
          applyCandidatesheetFilter={applyFilter}
          filterNumber={filterNumber}
          searchChange={searchChange}
          closeTag={closeTag}
          filterValues={filterValues}
          applyFilter={false}
          positionName={positionName}
          candidateFilterValue={candidateFilterValue}
        />
        {historyModal && <CandidateTimesheetHistory onClose={() => setHistoryModal(false)} data={checkHistoryData} />}
        {toEmailModal && <AddToEmail onClose={() => setToEmailModal(false)} ClickHandler={sendReminderProvider} emailList={providerEmailList} />}
        {notification && <NotificationAlert onClose={() => setNotification(false)} closable={true} type={type} icon={icon} >  {message}  </NotificationAlert>}
        <section className={Styles.positionWrapper}>
          <TabStrip selected={selected} onSelect={handleSelect}>
            <Tab title={'Candidate Timesheets'}>
              {timeSheetSelectedRow.length > 0 ? `${timeSheetSelectedRow.length} Timesheet selected` : ''}
              {timeSheetSelectedRow.length > 0 ? <img src={file_download} onClick={redirection} /> : ''}
              <CandidateTimesheet data={candidateSheetData} total={1000} pageSize={pageChange} setSort={setSort} applySort={applySort} sendReminder={sendReminder} showHistory={showHistory} />
            </Tab>
            <Tab title={'Timesheet and Billing settings'} >
              <TimesheetSettings clickHandler={submitSetting} defaultValues={defaultPaymentData} holidayList={holidayList} uploadList={uploadList} />
            </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  )
}

export default CompanyTimesheetSettings